"use-client"
import { Box, Typography } from "@mui/material";
import { getDictionary, getField } from '@/app/utils/translation/translation';
import './featureStyle.css';
import { useEffect, useState } from "react";
import { getSvg } from '@/app/utils/svgUtils';




export default function FeaturesSectionsMb({ language, dictionary, companyRef }: { language: any, dictionary: any, companyRef: any }) {
    const isArabic = language === 'arabic';
    const isFrench = language === 'french';
    const phoneNumber = '+971501286691';

    const [isTablet, setIsTablet] = useState(false);
    const [isLargeScreen, setIsLargeScreen] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const checkScreenSize = () => {
                const width = window.innerWidth;
                setIsLargeScreen(width >= 400 && width <= 1023);
            };
            checkScreenSize();
            window.addEventListener('resize', checkScreenSize);
            return () => {
                window.removeEventListener('resize', checkScreenSize);
            };
        }
    }, []);

    return (<>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: "100%" }}>
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <Typography variant="h3" component={"h3"}
                    textAlign={"center"} marginTop={"3rem"} color="var(--accent-primary)"
                    style={{
                        fontSize: "1rem",
                        fontFamily: "Century Gothic", fontWeight: "bold", letterSpacing: isArabic ? ' ' : "1px", width:"80%"
                    }}>
                    {isArabic ?
                        (<><span style={{ color: "var(--accent-secondary)" }}>!</span> {getField(dictionary, 'we', language)} </>)
                        :
                        (<>{getField(dictionary, 'we', language)} <span style={{ color: "var(--accent-secondary)" }}>!</span></>)}
                </Typography>
            </div>
        </div>
        <div style={{ display:"flex" , justifyContent:"center" , alignItems:"center" }}><Typography width='90%'  textAlign={"center"} variant="h5" fontSize="1rem" fontWeight={"bold"} sx={{ color: "var(--text-primary)" }} fontFamily={"Century Gothic"} marginTop={"40px"} paddingBottom={"2rem"}>{getField(dictionary, 'all-the-features-your-restaurant-app-needs', language)}  </Typography></div>
        <div ref={companyRef} style={{ padding: "40px", backgroundColor: "var(--bg-primary)", marginTop: isLargeScreen ? "11rem" : "6rem", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", position: "relative" }}>
            <div style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: "center", position: "relative", gap: isTablet ? "8rem" : "4rem" }}>
                <div style={{ backgroundColor: "var(--bg-primary)", display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10538.png' loading="lazy" alt="Feature" style={{ display: "block", width: "50%" }} />
                    <div style={{ position: "absolute", top: "-15%", right: "80%", borderRight: "5px solid var(--accent-secondary)", height: "35%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: "-10%",
                            left: "-20%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <img src="https://www.cloudix.ai/assests/images/featues/AI.svg" loading="lazy" width={isTablet ? "30px" : "15%"} height={isTablet ? "30px" : "15%"} alt="ai" />
                            <div style={{ width: isTablet ? "270px" : "190px", color: "var(--text-primary)" }}> {getField(dictionary, 'ai-powered-description', language)}</div>
                            <div className="circleLeft"> </div>

                        </Box>
                    </div>
                    <div style={{ position: "absolute", top: "52%", right: "70%", borderRight: "5px solid var(--accent-secondary)", height: isLargeScreen ? "70%" : "80%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: "100%",
                            left: "-20%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "7px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <img src="https://www.cloudix.ai/assests/images/featues/ingred.svg" loading="lazy" width={isTablet ? "30px" : "40px"} height={isTablet ? "30px" : "40px"} alt="ingredient" />
                            <div style={{ width: isTablet ? "290px" : "190px", color: "var(--text-primary)" }}>{getField(dictionary, 'variants-ingredeints-removal-modifiers', language)}</div>
                            <div className="circleLeft"> </div>

                        </Box>
                    </div>
                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10541.png' loading="lazy" alt="Feature" style={{ display: "block", width: "50%" }} />
                    <div style={{ position: "absolute", top: "-40%", right: "10%", borderRight: "5px solid var(--accent-secondary)", height: isLargeScreen ? "60%" : "50%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: "0",
                            right: "-70%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "1rem"
                        }}>
                            <img src="https://www.cloudix.ai/assests/images/featues/translate.svg" loading="lazy" width={isTablet ? "30px" : "30px"} height={isTablet ? "30px" : "30px"} alt="milti-lingual" />
                            <div style={{ width: isTablet ? "170px" : "100px", color: "var(--text-primary)" }}> {getField(dictionary, 'multi-lingual-ai', language)}</div>
                            <div className="circleLeft"> </div>

                        </Box>
                    </div>
                    <div style={{ position: "absolute", top: "80%", right: "7%", borderRight: "5px solid var(--accent-secondary)", height: "30%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            bottom: "-20%",
                            right: "-80%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <img src="https://www.cloudix.ai/assests/images/featues/darkmode.svg" loading="lazy" width={isTablet ? "30px" : "40px"} height={isTablet ? "30px" : "40px"} alt="darkmode" />
                            <div style={{ width: isTablet ? "170px" : "140px", color: "var(--text-primary)" }}>   {getField(dictionary, 'dark-mode', language)} {getField(dictionary, 'light-mode', language)}</div>
                            <div className="circleLeft"> </div>

                        </Box>
                    </div>
                </div>
                <div style={{ marginTop: "12rem", display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10540.png' loading="lazy" alt="Feature" style={{ display: "block", width: "50%" }} />
                    <div style={{ position: "absolute", top: "-10%", right: "60%", borderRight: "5px solid var(--accent-secondary)", height: "50%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: isLargeScreen ? "-14%" : "-25%",
                            left: "0",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                {getField(dictionary, 'combos', language)}
                                <img src="https://www.cloudix.ai/assests/images/featues/combos.svg" loading="lazy" width={isTablet ? "30px" : "30px"} height={isTablet ? "30px" : "30px"} alt="combo" />
                            </div>

                        </Box>
                    </div>

                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10542.png' loading="lazy" alt="Feature" style={{ display: "block", width: "50%" }} />
                    <div style={{
                        position: "absolute", top: "30%", right: "15%", borderRight: "5px solid var(--accent-secondary)",
                        height: isLargeScreen ? "75%" : "80%", width: "20%", boxSizing: "border-box"
                    }}>
                        <Box sx={{
                            position: "absolute",
                            bottom: isLargeScreen ? "-10%" : "-15%",
                            right: "-5rem",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box", display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                <div style={{ width: isTablet ? "270px" : "190px", color: "var(--text-primary)" }}>     {getField(dictionary, 'multi-resto-in-one-app', language)}</div>
                                <img src="https://www.cloudix.ai/assests/images/featues/resto.svg" loading="lazy" width={isTablet ? "40px" : "30px"} height={isTablet ? "40px" : "30px"} alt="resto" />
                            </div>

                        </Box>
                    </div>
                </div>
                <div style={{ marginTop: "12rem", display: "flex", justifyContent: "center", alignItems: "center", position: "relative" }}>
                    <img src='https://www.cloudix.ai/assests/images/featues/home page.png' loading="lazy" alt="Feature" style={{ display: "block" }} width={"50%"} height={"50%"} />
                    <div style={{ position: "absolute", top: "-40%", right: "66%", borderRight: "5px solid var(--accent-secondary)", height: "50%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: isLargeScreen ? "0%" : "-10%",
                            left: "-50%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                <div style={{ width: isTablet ? "270px" : "190px", color: "var(--text-primary)" }}>{getField(dictionary, 'gallery', language)} </div>
                                <img src="https://www.cloudix.ai/assests/images/featues/gallery.svg" loading="lazy" width={isTablet ? "40px" : "40px"} height={isTablet ? "40px" : "40px"} alt="gallery" />
                            </div>

                        </Box>
                    </div>
                    <div style={{ position: "absolute", top: "-10%", left: "0", borderRight: "5px solid var(--accent-secondary)", height: "30%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: isLargeScreen ? "-30%" : "-40%",
                            left: "0",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px",
                            boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <img src="https://www.cloudix.ai/assests/images/featues/menu.svg" loading="lazy" width={isTablet ? "40px" : "40px"} height={isTablet ? "40px" : "40px"} alt="menu" />
                            <div style={{ width: isTablet ? "200px" : "90px", color: "var(--text-primary)" }}> {getField(dictionary, 'multi-menu', language)}</div>
                            <div className="circleLeft"> </div>

                        </Box>
                    </div>
                    <div style={{ position: "absolute", top: "95%", left: "15%", borderRight: "5px solid var(--accent-secondary)", height: "32%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: "90%",
                            left: "-3rem",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px", fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                <div style={{ width: isTablet ? "270px" : "190px", color: "var(--text-primary)" }}> {getField(dictionary, 'direct-chat-with-the-customers', language)}</div>
                                <img src="https://www.cloudix.ai/assests/images/featues/chat.svg" loading="lazy" width={isTablet ? "30px" : "30px"} height={isTablet ? "30px" : "30px"} alt="chat" />
                            </div>

                        </Box>
                    </div>
                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10543.png' loading="lazy" alt="Feature" style={{ display: "block", width: "50%" }} />

                    <div style={{ position: "absolute", top: "80%", right: "30%", borderRight: "5px solid var(--accent-secondary)", height: "30%", width: "20%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            bottom: "-25%",
                            left: "-4rem",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box", display: "flex", alignItems: "center", gap: "10px", fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                <div style={{ width: isTablet ? "200px" : "140px", color: "var(--text-primary)" }}>{getField(dictionary, 'media-as-reels', language)}</div>
                                <img src="https://www.cloudix.ai/assests/images/featues/reels.svg" loading="lazy" width={isTablet ? "30px" : "30px"} height={isTablet ? "30px" : "30px"} alt="reels" />
                            </div>

                        </Box>
                    </div>
                </div>
                <div style={{ marginTop: isLargeScreen ? "7rem" : "5.5rem", display: "flex", justifyContent: "left", alignItems: "center", position: "relative" }}>
                    <img src='https://www.cloudix.ai/assests/images/featues/Group 10544.png' loading="lazy" alt="Feature" style={{ display: "block", width: "100%" }} />
                    <div style={{ position: "absolute", top: "75%", right: "50%", borderRight: "5px solid var(--accent-secondary)", height: "30%", width: "30%", boxSizing: "border-box" }}>
                        <Box sx={{
                            position: "absolute",
                            top: "80%",
                            left: "10%",
                            backgroundColor: "var(--section-bg)",
                            borderRadius: "25px", boxShadow: "rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px",
                            padding: "5px",
                            boxSizing: "border-box",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            fontSize: isTablet ? "1rem" : "1rem"
                        }}>
                            <div className="circleRight"> </div>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px", marginLeft: "auto" }}>
                                {getField(dictionary, 'feedbacks', language)}
                                <img src="https://www.cloudix.ai/assests/images/featues/feedback.svg" loading="lazy" width={isTablet ? "40px" : "40px"} height={isTablet ? "40px" : "40px"} alt="feedback" />
                            </div>

                        </Box>
                    </div>
                </div>
            </div>
        </div >



    </>)
}